import {
    AUTOMATION_ITEM_TYPE_COLORS,
    AUTOMATION_ITEM_TYPE_LABEL,
    SHARED_AUDIENCE,
    TASK_TYPE_COLORS,
    TASK_TYPE_LABEL,
} from "./calendarData";
import type {
    CustomItemType,
    ManagedItemType,
    SharedAudience,
    TaskType,
} from "./types";

export const ITEM_TYPE_COLOR_OPTIONS = ["#5b6ef5", "#f59e0b", "#10b981", "#fb7185", "#8b5cf6", "#06b6d4", "#14b8a6", "#f472b6", "#ef4444", "#84cc16", "#0ea5e9", "#a855f7", "#ec4899", "#22c55e", "#eab308", "#64748b", "#f97316", "#d946ef", "#0891b2", "#65a30d", "#dc2626", "#475569"];

export const getManagedItemTypes = (customItemTypes: CustomItemType[]): ManagedItemType[] => [
    ...customItemTypes.map(itemType => ({
        ...itemType,
        itemTypeUuid: itemType.itemTypeUuid || itemType.id,
    })),
];

export const isItemTypeAvailableForAudience = (itemType: ManagedItemType, audience: SharedAudience): boolean => {
    if (itemType.scope === "personal") return audience === SHARED_AUDIENCE.PERSONAL;
    if (itemType.scope === "company") return audience !== SHARED_AUDIENCE.PERSONAL;
    return true;
};

export const getItemTypeLabel = (taskType: TaskType | "", itemTypes: ManagedItemType[]): string => {
    if (!taskType) return "Calendar Item";
    return itemTypes.find(itemType => itemType.itemTypeUuid === taskType || itemType.id === taskType)?.label || TASK_TYPE_LABEL[taskType] || AUTOMATION_ITEM_TYPE_LABEL[taskType] || "Calendar Item";
};

export const getItemTypeColor = (taskType: TaskType | "", itemTypes: ManagedItemType[], fallback = "var(--calendar-accent)"): string => {
    if (!taskType) return fallback;
    return itemTypes.find(itemType => itemType.itemTypeUuid === taskType || itemType.id === taskType)?.color || TASK_TYPE_COLORS[taskType] || AUTOMATION_ITEM_TYPE_COLORS[taskType] || fallback;
};
